<div class="about">
    <section class="top">
        <div class="banner row justify-content-center" [style.background]="backgroundImageURL">
            <h1 class="m-auto">About Neprose</h1>
        </div>
    </section>
    <div class="container">
        <section>
            <div class="introduction">
                <h2 class="text-center">Introduction</h2>
                <p class="text-center">Nepal Property Services (NEPROSE) is the first internet based marketplace and real estate agency based in Jhapa through which our clients can sell, buy or rent real estates. In this portal owners of the real estates have the opportunity to offer their property to unlimited number of potential clients who visit this web page every day. Whether you are buying, selling, investing, developing property, seeking a home or offering one for rent, our partnership and all-professional staff provide the security, knowledge and support you need. We provide sales and rentals of the finest residential and commercial properties. We focus always in excellent customer service and quality properties.</p>
            </div>
        </section>
    </div>
    <section id="mission-vision">
        <div class="mission row">
            <div class="m-image">
            </div>
            <div class="m-text row m-auto">
                <h3 class="col-sm-12">Our Mission</h3>
                <p class="col-sm-12">To become the first choice of real estate institution in Nepal providing the best, creative and innovative services to our clients.</p>
            </div>
        </div>
        <div class="vision row">
            <div class="v-text row m-auto">
                <h3 class="col-sm-12">Our Vision</h3>
                <p class="col-sm-12">We assist our clients to make the best timely decisions and profit, utilizing our vast knowledge, resources and talent available.</p>
            </div>
            <div class="v-image">
            </div>
        </div>
    </section>
    <div class="container">
        <section id="features">
            <h2>Features</h2>
            <ul>
                <li>Simplifying Nepalese real estate market
                </li>
                <li>Participation with NEPROSE can help you work smarter
                </li>
                <li>Commission based services upon successful business transaction only
                </li>
                <li>Professional, honest & transparent business approach
                </li>
                <li>Reduce unnecessary contacts from non potential clients
                </li>
                <li>Innovative services provider with best technology and resources available in the market
                </li>
            </ul>
        </section>
    </div>
    <section id="story">
        <div class="container">
            <div class="story-behind-us">
                <h3>Story behind us</h3>
                <p>NEPROSE is the a trusted name in Nepali real estate market. Our team of expert property specialists provides you with the assurance and confidence you need in your real estate transactions. The firm’s founder & CEO is Sagar Dhakal,
                    with more than 15 years of experience in Nepal, Middle East and Europe. Everyone on our staff speaks fluent Nepali and English and our staffs speak Hindi, Bangla as well.</p>
            </div>
            <div class="company">
                <h3>Company</h3>
                <p>Nepal Property Services (NEPROSE) is registered in Jhapa, under the Nepal Government in 2016 (2073 B.S)
                </p>
            </div>
            <div class="bank">
                <h3>Bank / Payment</h3>
                <p>Bank name: Siddhartha Bank Limited
                </p>
                <p>Address: Birtamod, Jhapa, Nepal
                </p>
                <p>SWIFT: SIDDNPKAXXX
                </p>
                <p>Account name: Nepal Property Services
                </p>
                <p>Account no.: 02215091393
                </p>
                <p>Currency: NPR
                </p>
                <p><strong>If you wish to pay by bank draft or cheque the payee name must be 'Nepal Property Services'
                </strong></p>
            </div>
            <div class="office">
                <h3>Our Office</h3>
                <p>Our company is seated in Birtamod city, not very far from the Western Bus Stand. We’re always there, when and where you need us.</p>
            </div>
        </div>
    </section>
</div>